import {
  BEARER_TOKEN_NOT_AVAILABLE,
  ERROR_ADDING_OR_EDITING_GI_CONFIGURATION,
  FAILED_TO_ADD_OR_EDIT_GI_CONFIGURATION,
} from "../../constants/stringLiterals";
import { AddEditGiConfigurationPayload } from "../../data-model/addEditGiConfigrationPayload";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface AddEditGiConfigurationCallbacks {
  onSuccess?: (response: { status: number; data: any }) => void;
  onError?: (error: { status?: number; message: string }) => void;
}

export const addEditGiConfiguration = async (
  payload: AddEditGiConfigurationPayload,
  callbacks?: AddEditGiConfigurationCallbacks,
): Promise<any> => {
  let responseStatus: number | undefined;

  try {
    const token = await getBearerToken();

    if (!token) {
      callbacks?.onError?.({
        status: undefined,
        message: BEARER_TOKEN_NOT_AVAILABLE,
      });
      return;
    }

    const response = await fetch(API_ENDPOINTS.ADD_EDIT_GI_CONFIGURATION, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    responseStatus = response.status;

    if (!response.ok) {
      throw new Error(
        `${FAILED_TO_ADD_OR_EDIT_GI_CONFIGURATION}: ${response.statusText}`,
      );
    }

    const result = await response.json();
    callbacks?.onSuccess?.({ status: response.status, data: result });
    return result;
  } catch (error) {
    console.error(`${ERROR_ADDING_OR_EDITING_GI_CONFIGURATION}:`, error);
    const errorInfo = {
      status: responseStatus,
      message:
        error instanceof Error
          ? error.message
          : ERROR_ADDING_OR_EDITING_GI_CONFIGURATION,
    };
    if (callbacks?.onError) {
      callbacks.onError(errorInfo);
      return;
    }
    throw error;
  }
};
